import InvitationSessionService, {
  type InvitationSession,
} from "./invitation-session-service";

export const MOCK_INVITATION_SESSION: InvitationSession = {
  invite_payload: "dev-mock-payload",
  invite_signature: "dev-mock-signature",
  invite_version: "v1",
  email: "invited.customer@example.com",
  firstName: "Invited",
  lastName: "Customer",
  lang: "de-CH",
};

/** Artificial delay so local signup can show the invitation loading spinner. */
const DEV_DELAY_MS = 2000;

export default class DevInvitationSessionService implements InvitationSessionService {
  async getSession(_sessionId: string): Promise<InvitationSession> {
    await new Promise((resolve) => setTimeout(resolve, DEV_DELAY_MS));
    return MOCK_INVITATION_SESSION;
  }
}
